import { render } from "./GestaoPage2.vue?vue&type=template&id=1ea857cc&scoped=true"
import script from "./GestaoPage2.vue?vue&type=script&lang=js"
export * from "./GestaoPage2.vue?vue&type=script&lang=js"

import "./GestaoPage2.vue?vue&type=style&index=0&id=1ea857cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea857cc"]])

export default __exports__